const routeEnpoints = {
    default: '/',
    register: '/register',
    twoFA: '/2fa',
    consent: '/termsprivacy',
    sandboxLogin: '/sandbox-login',
    resetPassword: '/forgot-password',
    setResetPassword: '/reset-password',
    setInvitePassword: '/verify-account',
    verifyEmail: '/verify/email',
    signupv2: '/signup-v2',
    dashboard: '/dashboard',
    billingDashboard: '/billing/dashboard',
    integration: '/integrations',
    settings: '/settings',
    guides: '/guides',
    userSearch: '/user/search',
    workflows: '/workflows',
    themes: '/workflows/themes',
    themeEditor: '/workflows/themes/:nanoid',
    signDocument: '/signDocument',
    tcm: '/tcm',
    users: '/users',
    logout: '/logout',
};
export default routeEnpoints;
